import { useEffect, useState } from 'react';
import * as Yup from 'yup';

import { useSelector } from 'react-redux';
import { selectUserToken } from '../../../../redux/features/user/userSelectors';
import {
  useAddVisitMutation,
  useDeleteVisitMutation,
  useUpdateVisitMutation,
} from '../../../../redux/services/visits/visitsApi';

import { FormTemplate } from '../FormTemplate';
import { DeleteDialogButton } from '../../DeleteDialogButton';
import { InputList } from '../../inputs/InputList';

import {
  initialValues,
  mock,
  validationSchemaVisit,
} from '../../../../lib/mocks/add-visit-mock';
import {
  getDefaultValues,
  getInitialValues,
  handleResponseError,
} from '../../../../utils/data';
import { closeDialog, showError } from '../../../../utils/ui';

export const AddVisitForm = ({
  visit = {},
  isEdit = false,
  setShowAddVisitForm = () => {},
  realtyId,
}) => {
  const [newInitialValues, setNewInitialValues] = useState({
    ...initialValues,
  });
  const [inputs, setInputs] = useState([]);
  const [error, setError] = useState('');

  const userToken = useSelector(selectUserToken);

  const [addNewVisit, { isLoading: isAddingLoading, error: addingError }] =
    useAddVisitMutation();
  const [editVisit, { isLoading: isEditingLoading, error: editingError }] =
    useUpdateVisitMutation();
  const [deleteVisit, { isLoading: isDeletingLoading, error: deleteingError }] =
    useDeleteVisitMutation();

  const handleSubmit = async values => {
    setError('');

    let response;
    let errorStatus;

    if (isEdit) {
      response = await editVisit({
        token: userToken,
        id: visit.id,
        data: values,
      });

      errorStatus = await handleResponseError(
        response?.error,
        editingError,
        () => closeDialog({ setState: setShowAddVisitForm })
      );
    } else {
      response = await addNewVisit({
        token: userToken,
        data: values,
        realty_id: realtyId, //hardcode
      });

      errorStatus = await handleResponseError(
        response?.error,
        addingError,
        () => closeDialog({ setState: setShowAddVisitForm })
      );
    }

    setError(errorStatus);
  };

  const handleDelete = async setIsDeleteClick => {
    setIsDeleteClick(false);
    setError('');

    const response = await deleteVisit({
      token: userToken,
      id: visit.id,
    });

    const errorStatus = await handleResponseError(
      response?.error,
      deleteingError,
      () => closeDialog({ setState: setShowAddVisitForm })
    );

    setError(errorStatus);
  };

  const updateMock = async () => {
    if (isEdit) {
      setNewInitialValues(prevValues => getInitialValues(visit, prevValues));

      const updatedMock = getDefaultValues(visit, mock);

      setInputs(updatedMock);
    } else {
      setNewInitialValues(initialValues);
      setInputs(mock);
    }
  };

  useEffect(() => {
    showError(error);
  }, [error]);

  useEffect(() => {
    updateMock();
  }, []);

  return (
    <div className="relative flex flex-wrap gap-4 w-full exclude-click dialog-with-click">
      <FormTemplate
        initialValues={newInitialValues}
        validationSchema={Yup.object(validationSchemaVisit)}
        handleSubmitForm={handleSubmit}
        buttonText={'Save'}
        bgColor={'bg-purpleColor border-purpleColor'}
      >
        {formProps => (
          <>
            <InputList
              formProps={formProps}
              inputs={inputs}
            />

            <div className="flex flex-wrap items-center gap-3 w-full">
              {isEdit && (
                <DeleteDialogButton
                  isDeletingLoading={isDeletingLoading}
                  handleDelete={handleDelete}
                  error={error}
                />
              )}
            </div>
          </>
        )}
      </FormTemplate>
    </div>
  );
};
